// src/lib/base-visee.js — QUELLE BASE CE NAVIGATEUR VISE (P-2.57).
//
// Le bandeau d'aperçu disait « DONNÉES RÉELLES » sur tout aperçu, même branché
// sur la base d'essai (constat du 30/10). Il dit maintenant la base que le
// code du navigateur vise vraiment, déduite de l'adresse Supabase inscrite
// dans le bundle (REACT_APP_SUPABASE_URL), jamais de la documentation.
//
// Les deux références sont celles de lib/base-essai-ref.js (source serveur) :
// l'écran ne peut pas lire lib/ (CRA), d'où cette copie, tenue égale par
// src/lib/base-visee.test.js (un écart fait rougir).

export const REF_REELLE = "cxgfumbkagbvryfhmuod";
export const REF_ESSAI = "coezrjebounteuvrowjg";
export const ESSAI_URL = `https://${REF_ESSAI}.supabase.co`;

// La MÊME règle que estAdresseEssai (lib/base-essai-ref.js) : l'adresse
// exacte de l'essai, https et .co seulement, barre finale tolérée. Copie
// tenue égale au serveur par src/lib/base-visee.test.js (mêmes entrées,
// même réponse). Plus large ici = un aperçu dit « essai » là où le serveur
// dit non : interdit.
export function estAdresseEssai(url) {
  if (typeof url !== "string") return false;
  const u = url.trim();
  if (u.toLowerCase().includes(REF_REELLE)) return false;
  return u.replace(/\/+$/, "") === ESSAI_URL;
}

// La référence de projet lue dans l'adresse (https://<ref>.supabase.co), ou
// null si l'adresse est absente ou d'une autre forme.
export function refDeLAdresse(url) {
  if (typeof url !== "string") return null;
  const m = url.trim().match(/^https?:\/\/([a-z0-9]+)\.supabase\.(co|in)\/?$/i);
  return m ? m[1].toLowerCase() : null;
}

// « reelle » | « essai » | « inconnue », et la référence lue (ou null).
// Une adresse qui n'est ni l'une ni l'autre est « inconnue » : le bandeau
// reste alors au rouge, on ne présume jamais l'essai.
export function baseVisee(env = process.env) {
  const url = env && env.REACT_APP_SUPABASE_URL;
  if (estAdresseEssai(url)) return { base: "essai", ref: REF_ESSAI };
  const ref = refDeLAdresse(url);
  if (ref === REF_REELLE) return { base: "reelle", ref };
  // Toute autre adresse, y compris une forme approchée de l'essai (http,
  // majuscules, .in) : inconnue, donc rouge.
  return { base: "inconnue", ref };
}
